import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import {
  useDataSharePresetsStore,
  useDataSharesStore,
  usePartnersStore,
} from '@/stores';

export function usePartnersUsingPreset(
  feedId: number,
  baseSourceId?: number,
  presetId?: number,
) {
  const partnersStore = usePartnersStore();
  const { partnerOrgs } = storeToRefs(partnersStore);
  const { getEffectiveSharingRules } = useDataSharesStore();
  const { getDefaultPresetId } = useDataSharePresetsStore();

  const defaultPresetId = computed(() =>
    getDefaultPresetId(feedId, baseSourceId),
  );

  // Get effective sharing rules for all active partners
  const effectiveSharingRulesPerPartner = computed(() => {
    const partnerIds = partnerOrgs.value.map((org) => org.id);
    return getEffectiveSharingRules(partnerIds);
  });

  // Find partners that use the default preset at least once
  const partnersUsingPreset = computed(() =>
    partnerOrgs.value.filter((org) =>
      Object.values(effectiveSharingRulesPerPartner.value[org.id] || {}).some(
        (rule) =>
          rule.data_share_presets_id === (presetId || defaultPresetId.value),
      ),
    ),
  );

  return { partnersUsingPreset };
}
